<template>
  <transition
    name="zm-zoom-in-top"
    @after-leave="handleLeave"
  >
    <ul
      role="menu"
      tabindex="-1"
      class="zm-dropdown-menu zm-popper"
      :class="[size && `zm-dropdown-menu--${size}`,popperClass]"
      v-show="showPopper"
      ref="list"
      @keydown="handleListKeyDown"
      :aria-activedescendant="activedescendant"
    >
      <slot></slot>
    </ul>
  </transition>
</template>
<script>
  import Popper from '../../utils/vue-popper';
  import Emitter from '../../mixins/emitter';

  export default {
    name: 'ZmDropdownMenu',

    componentName: 'ZmDropdownMenu',

    mixins: [Popper, Emitter],

    props: {
      visibleArrow: {
        type: Boolean,
        default: false
      },
      arrowOffset: {
        type: Number,
        default: 0
      },
      popperClass: String
    },

    data() {
      return {
        size: this.dropdown.dropdownSize,
        activedescendant: null
      };
    },

    inject: ['dropdown'],

    created() {
      this.$on('updatePopper', () => {
        if (this.showPopper) this.updatePopper();
      });
      this.$on('visible', (val) => {
        this.showPopper = val;
      });
      this.$on('focusList', (val) => {
        if (val) {
          this.$refs.list.focus();
        }
      });
      this.$on('activedescendant', (val) => {
        this.activedescendant = val;
      });
    },

    mounted() {
      this.dropdown.popperElm = this.popperElm = this.$el;
      this.referenceElm = this.dropdown.$el;
      // compatible with 2.6 new v-slot syntax
      // issue link https://github.com/ElemeFE/element/issues/14345
      this.dropdown.initDomOperation();
    },

    methods: {
      handleLeave() {
        this.doDestroy();
      },
      handleListKeyDown(e) {
        this.dispatch('ZmDropdown', 'menu-list-keydown', e);
      }
    },

    beforeDestroy() {
      this.handleLeave();
    },

    watch: {
      'dropdown.placement': {
        immediate: true,
        handler(val) {
          this.currentPlacement = val;
        }
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(dropdown-menu) {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 4px;
    margin: 0;
    background-color: $--color-white;
    border: 1px solid transparent;
    border-radius: $--dropdown-menu-border-radius;
    box-shadow: $--dropdown-menu-box-shadow;

    &:focus {
      outline: none;
    }
  }

  .zm-theme--dark {
    @include b(dropdown-menu) {
      background-color: #131619;
      border-color: #252A30;
    }
  }
</style>
